import { Box, Stack, Text } from '@chakra-ui/react';

import ExpertIntegrationContainerHeader from './ExpertIntegrationContainerHeader';

interface ExpertIntegrationContainerProps {
  /** Whether the integration is disabled @default false */
  isDisabled?: boolean;
  /** Whether to render the setup button @default false */
  renderSetupButton?: boolean;
  /** Whether to render the integration status @default false */
  renderIntegrationStatus?: boolean;
  /** Whether the integration is enabled @default false */
  integrationEnabled?: boolean;
  /** The name of the integration */
  integrationName: string;
  /** The description of the integration */
  integrationDescription: string;
  /** Callback function to handle the setup button click */
  handleOnSetupButtonClick: () => void;
  /** Callback function to handle manual sync */
  onManualSync?: () => void;
  /** Last synced timestamp */
  lastSynced?: string;
  /** The icon of the integration */
  integrationIcon: React.ReactNode;
  /** The children of the container @default undefined */
  children?: React.ReactNode;
  /** Whether the integration has an error @default false */
  hasError?: boolean;
  /** The error message of the integration @default undefined */
  errorMessage?: string | undefined;
}

export default function ExpertIntegrationContainer({
  isDisabled = false,
  renderSetupButton = false,
  renderIntegrationStatus = false,
  integrationEnabled = false,
  integrationName,
  integrationDescription,
  handleOnSetupButtonClick,
  onManualSync,
  lastSynced,
  integrationIcon,
  children = undefined,
  hasError = false,
  errorMessage = undefined,
}: ExpertIntegrationContainerProps) {
  return (
    <Stack>
      <Box
        padding={6}
        backgroundColor="neutral.0"
        border="1px solid"
        borderColor={hasError ? 'red.300' : 'neutral.100'}
        borderRadius="24px"
        opacity={isDisabled ? 0.5 : 1}
      >
        <ExpertIntegrationContainerHeader
          isDisabled={isDisabled}
          renderSetupButton={renderSetupButton}
          renderIntegrationStatus={renderIntegrationStatus}
          integrationEnabled={integrationEnabled}
          integrationName={integrationName}
          integrationDescription={integrationDescription}
          handleOnSetupButtonClick={handleOnSetupButtonClick}
          integrationIcon={integrationIcon}
          onManualSync={onManualSync}
          lastSynced={lastSynced}
        />

        {children}
      </Box>

      {hasError && errorMessage && (
        <Text fontSize="14px" fontWeight={500} color="red.300">
          {errorMessage}
        </Text>
      )}
    </Stack>
  );
}
